<div class="m-1 mt-2">
  <app-document-library-search 
    [feature]="feature"
    (emitSelectedData)="onSelectionOrDeselection($event)"
    (shouldAddTrainingItemAsDocumentButtonDisplayed)="showOrHideAddButton($event)"
    [panelListScreen]="skillDocumentDetails">
  </app-document-library-search>
</div>
<div class="col mb-2 card flex" *ngIf="showAddButton">
  <p-splitButton class="p-splitbutton-menubutton splitBtn" label="Add and Close" (onClick)="addskillAndClose()" [model]="items"></p-splitButton>
</div>
